





define(['endpoints', 'rest/request/requestFactory', 'apiKeyNames'],
    function(endpoints, requestFactory, ApiKeyNames) {
        'use strict';

        return function() {
            return {
                incidentsDetails: requestFactory.single(endpoints.trafficIncidents, ApiKeyNames.traffic)
            };
        };
    });



// WEBPACK FOOTER //
// ./rest/trafficIncidents.js